import { CoverTypes } from 'shared/types/global'
import Text from 'shared/ui/Text'

import { Container } from './Styles'
import { ReactComponent as BookIcon } from './icons/book.svg'

type CoverPagePreviewProps = {
  coverType: CoverTypes
}

const CoverPagePreview: React.FC<CoverPagePreviewProps> = ({
  coverType
}) => {
  return (
    <Container>
      <BookIcon />

      <Text
        marginTop={10}
        id="Pages.cover.description.hard"
        size={10}
        color={theme => theme.color.base.c7}
        align="center"
        lineHeight="14px"
      />
    </Container>
  )
}

export default CoverPagePreview
